import { AngularInjector } from '../../../common/AngularUtils';

UserAnalyticsService.useInstance = () => AngularInjector.useInjectedClass(UserAnalyticsService);
UserAnalyticsService.$inject = ['userAnalytics'];
export default function UserAnalyticsService(userAnalytics) {
    this.event = userAnalytics.event;
}
